import { createMatchSelector } from 'connected-react-router';
import queryString from 'query-string';
import { State } from '../store/reducer';

/*
  From Matt - Need to rewrite or remove this class now that react-router has hooks for params. 
  Should move to doing const { param } = useParams() in component over this class.
*/

export const Selectors = {
  getUrl: (): string => window.location.href,

  getPath: (state: State): string => state.router.location.pathname,

  // Not exactly like redux-little-routers get result need to reconsider
  getEndofPath: (state: State) => {
    const parts = state.router.location.pathname.split('/');
    const lastSegment = parts.pop() || parts.pop();
    return lastSegment;
  },

  getQuery: (state: State, key: string): string | null => {
    if (!key) {
      return null;
    }
    const parsed = state.router.location.search && queryString.parse(state.router.location.search);
    if (!parsed) {
      return null;
    }
    return parsed[key] as string;
  },

  getHash: (state: State): string => state.router.location.hash,

  getParam: (state: State, param: string) => {
    switch (param) {
      case 'siteId': {
        return Selectors.getSiteId(state);
      }
      case 'brandId': {
        return Selectors.getBrandId(state);
      }
      case 'groupId': {
        return Selectors.getGroupId(state);
      }
      case 'campaignId': {
        return Selectors.getCampaignId(state);
      }
    }
  },

  // A/B Test
  getSplitTestId: (state: State): string => {
    const matchSelector = createMatchSelector('/sites/:siteId/campaigns/split_tests/:splitTestId');
    const match = matchSelector(state);
    if (match) {
      return match.params['splitTestId'];
    }
  },

  // Client
  getClientLevel: (state: State): string | null =>
    state.router.location.pathname && state.router.location.pathname.split('/')[1],

  // Client Wizard
  getCurrentClientWizardStep: (state: State): string | null => {
    const matchSelector = createMatchSelector(':clientLevel*/:id*/create/:step');
    const match = matchSelector(state);
    if (match) {
      return match.params['step'];
    }
  },

  // User Wizard
  getCurrentUserWizardStep: (state: State): string | null => {
    const matchSelector = createMatchSelector('/user-management/users/new-user/:step');
    const match = matchSelector(state);
    if (match) {
      return match.params['step'];
    }
  },

  // User sFTP Wizard
  getCurrentSftpUserWizardStep: (state: State): string | null => {
    const matchSelector = createMatchSelector('/user-management/sftp-users/new-sftp-user/:step');
    const match = matchSelector(state);
    if (match) {
      return match.params['step'];
    }
  },

  getSiteId: (state: State): string | null => {
    const matchSelector = createMatchSelector('/sites/:siteId');
    const match = matchSelector(state);
    if (match) {
      return match.params['siteId'];
    }
  },

  getBrandId: (state: State): string | null => {
    const matchSelector = createMatchSelector('/brands/:brandId');
    const match = matchSelector(state);
    if (match) {
      return match.params['brandId'];
    }
  },

  getGroupId: (state: State): string | null => {
    const matchSelector = createMatchSelector('/groups/:groupId');
    const match = matchSelector(state);
    if (match) {
      return match.params['groupId'];
    }
  },

  // Campaigns
  getCampaignId: (state: State): string => {
    const matchSelector = createMatchSelector([
      '/sites/:siteId/campaigns/campaigns/:campaignId',
      '/sites/:siteId/campaigns/onsite/:campaignId/settings',
    ]);
    const match = matchSelector(state);
    if (match) {
      return match.params['campaignId'];
    }
  },

  getCampaignIdControlCenter: (state: State): string => {
    const matchSelector = createMatchSelector('/sites/:siteId/campaigns/campaigns/:campaignId/control_center/:tab');
    const match = matchSelector(state);
    if (match) {
      return match.params['campaignId'];
    }
  },

  getControlCenterTab: (state: State): string | null => {
    const matchSelector = createMatchSelector('/sites/:siteId/campaigns/campaigns/:campaignId/control_center/:tab');
    const match = matchSelector(state);
    if (match) {
      return match.params['tab'];
    }
  },

  // Ruleset split tests
  getSplitTestCreationWizardPage: (state: State): string => {
    const matchSelector = createMatchSelector('/sites/:siteId/campaigns/split_tests/create/:splitTestWizardPage');
    const match = matchSelector(state);
    if (match) {
      return match.params['splitTestWizardPage'];
    }
  },

  isMarketingPermissionPage: (state: State): boolean => {
    if (!state.router.location.pathname.endsWith('marketing-permissions')) {
      return false;
    }
    const marketingPermissionRoute = '/sites/:siteId/settings/marketing-permissions';
    const isMP = createMatchSelector(marketingPermissionRoute);
    const matchMP = isMP(state);
    return !!matchMP;
  },
};
